import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  name: 'addHuman',
})
export class AddHumanPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: any): string {
    if (value == null || value === '') {
      return value;
    } else {
      return value.toString() + ' ' + this.translate.instant('UNIT_PERSON')
        ;
    }
  }
}
